import React from "react";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../../UTILS/ANIMATION/motionVariants";

// Generic scroll-reveal wrapper. Drop any element in, it fades/slides into
// place the first time it enters the viewport. Never alters layout at rest
// (final state matches the un-animated element exactly).
const resolveMotionTag = (as) => {
  if (typeof as === "string") return motion[as] || motion.div;
  return motion(as);
};

const Reveal = ({
  as = "div",
  variants,
  delay = 0,
  className,
  children,
  ...rest
}) => {
  const MotionTag = resolveMotionTag(as);
  const resolvedVariants = variants ? variants(delay) : fadeUp(delay);

  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={resolvedVariants}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
